<template>
  <div class="mb-3">
    <custom-callout
      :border-color="data.status.color"
      controlled
      has-toggle
      :opened="data.opened"
      @click:open="toggle(sections.AdditionalInfo)"
    >
      <div class="row py-2 mr-md-0 n-ml">
        <div class="col-12 col-md text-center border-right">
          <div
            :class="`badge badge-pill font-14 mt-3 py-2 mx-auto`"
            :style="{ 'background-color': '#fed8bc', color: '#d44d28' }"
          >
            {{ data.area.name }}
          </div>
          <div>
            <span class="font-16 text-muted">
              No. de Cuestionario:
            </span>
          </div>
          <div>
            <span class="font-16 color-black ">
              {{ data.number | empty }}
            </span>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="row pt-2 align-items-center">
            <div class="col-12 col-md-8 custom-pl">
              <div class="d-flex flex-column">
                <span class="color-gray-6 d-block font-14">
                  Nombre del Cuestionario:
                </span>
                <span class="font-16 color-black ">
                  {{ data.questionnaireType.name | empty }}
                </span>
              </div>
            </div>
            <div class="col-12 col-md custom-pl">
              <div class="d-flex flex-column">
                <label class="text-muted">Estatus:</label>
                <custom-balloon
                  :background-color="data.status.color"
                  dot
                  :text="data.status.name"
                />
              </div>
            </div>
            <div class="col-12 col-md custom-pl text-md-center">
              <div class="d-flex flex-column">
                <dropdown
                  class="actions-dropdown"
                  :items="actionItems"
                  title="Acciones"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #edition>
        <div class="bg-gray p-3">
          <div class="bg-white p-3 rounded">
            <additional-info v-if="isAdditionalInfoOpen" :value="data" />
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import Dropdown from 'dropdown';
import CustomBalloon from 'custom-balloon';

//components
import AdditionalInfo from './AdditionalInfo.vue';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { announcementQuestionnaireStatuses } from '@/utils/constants/announcementQuestionnaireStatus';

export default {
  name: 'ResultRow',
  components: {
    CustomCallout,
    Dropdown,
    CustomBalloon,
    AdditionalInfo,
  },
  mixins: [alertMixin],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeSection: null,
    };
  },
  computed: {
    sections() {
      return Object.freeze({
        AdditionalInfo: 0,
      });
    },
    isSubmitted() {
      return (
        this.data?.status?.id === announcementQuestionnaireStatuses.Submitted
      );
    },
    isDraft() {
      return this.data?.status?.id === announcementQuestionnaireStatuses.Draft;
    },
    isPublished() {
      return (
        this.data?.status?.id === announcementQuestionnaireStatuses.Published
      );
    },
    actionItems() {
      let actions = [
        {
          name: 'viewAdditionalInfo',
          label: 'Ver Información Adicional',
          icon: 'fas fa-info-circle text-green pr-1',
          visible: true,
          click: () => {
            this.data.opened = true;
            this.activeSection = this.sections.AdditionalInfo;
          },
        },
        {
          name: 'edit',
          label: 'Continuar Edición',
          icon: 'fas fa-file-import text-green pr-1',
          visible: this.isDraft,
          click: () => {
            this.$router.push({
              name: 'questionConfigurationDetail',
              params: {
                id: this.data.id,
              },
            });
          },
        },
        {
          name: 'returnToDraft',
          label: 'Regresar a Borrador',
          icon: 'fas fa-reply-all text-green',
          variant: 'success',
          visible: this.isSubmitted,
          click: async () => {
            this.$emit('returnToDraft', this.data.id);
          },
        },
        {
          name: 'preview',
          label: 'Vista Preliminar',
          icon: 'fas fa-eye text-green',
          variant: 'success',
          visible: this.isSubmitted || this.isPublished,
          click: async () => {
            this.$router.push({
              name: 'questionConfigurationPreview',
              params: { id: this.data.id },
            });
          },
        },
        {
          name: 'remove',
          label: 'Eliminar',
          icon: 'fas fa-trash-alt text-danger pr-1',
          visible: this.canRemove,
          click: () => this.$emit('remove', this.data.id),
        },
        {
          name: 'duplicate',
          label: 'Duplicar',
          icon: 'fas fa-copy text-green pr-1',
          visible: this.canDuplicate,
          click: () => this.$emit('duplicate', this.data),
        },
      ];

      return actions;
    },
    isAdditionalInfoOpen() {
      return this.activeSection === this.sections.AdditionalInfo;
    },
    canRemove() {
      return (
        this.isDraft &&
        this.userHasPermissions('provider.questionconfigsettings.delete')
      );
    },
    canDuplicate() {
      return (
        this.isPublished &&
        this.userHasPermissions('provider.questionconfigsettings.copy')
      );
    },
  },
  methods: {
    toggle(section) {
      if (this.data.opened) {
        this.activeSection = null;
        this.data.opened = false;
        return;
      }
      this.activeSection = section;
      this.data.opened = true;
    },
  },
};
</script>
<style lang="css" scoped></style>
